import React, {useCallback} from 'react';
import {UnrealEngineNavigation} from '@wf-components/navigation-react';
import {NavSearchEvent, NavCtaClickEvent} from '@wf-components/navigation-consumer';
import {getLocale} from '@epic-core/common';
import {useLocation} from 'react-router-dom';
import root from 'window-or-global';

const isPathDisabled = (currentPath: string, disablePaths?: string[]) => {
    let disable = false;
    if (disablePaths && disablePaths?.length) {
        for (let i = 0; i < disablePaths?.length; i++) {
            if (currentPath.includes(disablePaths[i])) {
                disable = true;
            }
        }
    }
    return disable;
};

interface Props {
    disablePaths?: string[];
}

export const GlobalNavWrapper = ({disablePaths}: Props): JSX.Element | null => {
    const location = useLocation();
    const pathname = location.pathname;
    const locale = getLocale();
    const blackListLangCodes = ['de', 'es-ES', 'fr', 'pt-BR'];
    const clientConfig = root.clientEnvConfig || {};
    const serverUrl = clientConfig.EPIC_SERVER_URL;

    const navOnSearch = useCallback((e: CustomEvent<NavSearchEvent>) => {
        if (e.detail.value) {
            e.detail.originalEvent?.preventDefault();
            root.location.href = `${serverUrl}/search?keyword=${e.detail.value}`;
        }
    }, []);

    const ctaOnClick = useCallback((e: CustomEvent<NavCtaClickEvent>) => {
        if (e.detail) {
            e.detail.originalEvent?.preventDefault();
            root.location.href = `${serverUrl}/download?start=true`;
        }
    }, []);

    const disable = isPathDisabled(pathname, disablePaths);
    if (disable) return null;

    return (
        <UnrealEngineNavigation
            domain={serverUrl}
            blackListLangCodes={blackListLangCodes}
            locale={locale}
            disableUser
            navOnSearch={navOnSearch}
            ctaOnClick={ctaOnClick}
        />
    );
};
